function getImplementation() {
  var impl = {
    getResource: function getResource(lng, ns, key) {
      return {};
    },
    setResource: function setResource(lng, ns, key, value) {},
    getResourceBundle: function getResourceBundle(lng, ns, cb) {
      cb({});
    },
    getDefaultNS: function getDefaultNS() {},
    getLng: function getLng() {},
    getSourceLng: function getSourceLng() {},
    getLocizeDetails: function getLocizeDetails() {
      return {};
    },
    bindLanguageChange: function bindLanguageChange(cb) {},
    bindMissingKeyHandler: function bindMissingKeyHandler(cb) {},
    triggerRerender: function triggerRerender() {}
  };
  return impl;
}

export { getImplementation };
